import { useMutation } from '@tanstack/react-query';

import {
  MfaAuthenticateRequest,
  MfaAuthenticateResponse,
  MfaResendRequest,
  MfaResendResponse,
  MfaSkipRequest,
  MfaVerifyRequest
} from '../components/LoginModal/LoginModal.types';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export default function useMfa() {
  const axios = useAxios();

  const authenticateMfa = useMutation(
    async (data: MfaAuthenticateRequest) => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_AUTHENTICATE),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data as MfaAuthenticateResponse;
    }
  );

  const verifyMfa = useMutation(
    async (data: MfaVerifyRequest) => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_VERIFY),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data;
    }
  );

  const skipMfa = useMutation(
    async (data: MfaSkipRequest) => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_SKIP),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );

      return response.data;
    }
  );

  const resendMfa = useMutation(
    async (data: MfaResendRequest) => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.MFA_RESEND),
        data,
        { withCredentials: true },
        { shouldClearSessionOnUnauthorized: false }
      );
      return response.data as MfaResendResponse;
    }
  );

  return {
    authenticateMfa,
    verifyMfa,
    skipMfa,
    resendMfa
  };
}


